export default "__VITE_ASSET__COsdgGUk__"